import {PagewebLayoutState} from './PagewebLayoutState.interface';

/**
 * 주의 : mutable. immer 가 적용된 경우만 사용해야함
 * parent 의 relation 을 생성하여 준비합니다.
 * relation 에 push 하는 주체는 children 입니다. 예를들어 section 의 childrenIds 는 자식인 group 이 추가될 때 마다 push 됩니다. 만약 부모의 relation 이 미리 생성되어있지 않으면 자식에서 push 할 때 마다 부모의 relation 의 relation 을 체크하고 생성해야하기 때문에 번거롭습니다. 이 함수를 통해 자식을 추가하기 전에
 */
export function initializeParentRelation({
  state,
  relationKey,
  id,
  parentId,
}: {
  state: PagewebLayoutState;
  relationKey: keyof PagewebLayoutState['relations'];
  id: string;
  parentId?: string;
}) {
  if (
    relationKey === 'sections' ||
    relationKey === 'groups' ||
    relationKey === 'nestedGroups'
  ) {
    if (!parentId) {
      throw new Error('잘못된 정보입니다');
    }
    state.relations[relationKey][id] = {
      parentId,
      childrenIds: [],
    };
  } else if (relationKey === 'items') {
    if (!parentId) {
      throw new Error('잘못된 정보입니다');
    }
    state.relations[relationKey][id] = {
      parentId,
    };
  } else if (relationKey === 'layouts') {
    state.relations[relationKey][id] = {childrenIds: []};
  } else {
    throw new Error('잘못된 인자입니다');
  }
}
